import { BannerWcmDto, sendFeedbackBanner } from "@sparkasse/commons";
import ButtonText2 from "component/buttonText2/buttonText2.component";
import CarouselCustom from "component/carouselCustom/carouselCustom.component";
import { navigateToPage, WEBPAGE } from "component/history/history.component";
import { base64ToImageSrc, sendEventToMatomo } from "helpers/utilities";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { AnyAction, bindActionCreators, Dispatch } from "redux";
import { AppState } from "../../reducers";

const Banner: React.FC<Props> = (props: Props) => {

  const { t } = useTranslation();

  const {
    funzionalita,
    banners,
    className
  } = props;

  const [slideIndex, setSlideIndex] = useState(0);
  const [isFirstRender, setIsFirstRender] = useState(true);

  useEffect(() => {
    setIsFirstRender(false);
  }, []);

  useEffect(() => {
    if (banners.length > 1 && !isFirstRender) {
      const bannerCampaignDetails = [{
        messaggioId: banners[slideIndex].messaggioId,
        campaignId: banners[slideIndex].campaignId,
        campaignCode: banners[slideIndex].campaignCode
      }];
      props.sendFeedbackBanner({ bannerCampaignDetails, eventContext: funzionalita, eventName: 'BANNER_VISUALIZZATO', eventData: `banner ${banners[slideIndex].titolo} visualizzato` });
    }
  }, [slideIndex]);

  const handleNavigation = (banner: BannerWcmDto) => {
    const eventData = `click su pulsante banner con titolo titolo: "${banner.titolo}" e id: ${banner.messaggioId} con navigazione verso ${banner.urlLink || banner.codiceServizio}`
    sendEventToMatomo('CLICK_RATE_BANNER', eventData, `titolo banner: "${banner.titolo}", id banner: ${banner.messaggioId}`);
    const bannerCampaignDetails = [{
      messaggioId: banner.messaggioId,
      campaignId: banner.campaignId,
      campaignCode: banner.campaignCode
    }];
    props.sendFeedbackBanner({ bannerCampaignDetails, eventContext: funzionalita, eventName: 'CLICK_RATE_BANNER', eventData: eventData });
    if (banner.urlLink) {
      if (banner?.urlLink?.toLowerCase().startsWith('http://perte.it/')) {
        navigateToPage(WEBPAGE.CatalogoProdotti.url, { idProdotto: banner.urlLink.substr('http://PERTE.it/'.length) })
      } else if (banner?.urlLink) {
        window.open(banner.urlLink);
      }
    } else if (banner.codiceServizio) {
      navigateToPage(banner.codiceServizio)
    }
  };

  const BannerItems = (
    !banners.length ? [] : banners.map((banner, i) =>
      <div
        className="banner-body"
        style={{ display: slideIndex === i ? 'flex' : 'none' }}
        key={`banner-slide-${i}`}
        aria-selected={slideIndex === i}
        aria-hidden={slideIndex !== i ? "true" : "false"}
        tabIndex={slideIndex === i ? 0 : -1}
        aria-roledescription="slide"
      >

        <div className="txtView">
          {banner.visualizzaTitolo && !!banner.titolo ?
            <span
              className="txtTitle titoloBanner"
            >
              {banner.titolo}
            </span> : ""
          }
          <span className="txtDescription" dangerouslySetInnerHTML={{ __html: banner.testo || "" }} />
        </div>
        {!!banner.immagine &&
          <div className="banner-icon-view iconView">
            <img
              className="banner-icon-view-img"
              src={base64ToImageSrc(banner.immagine)}
              aria-hidden={true}
              alt=""
            />
          </div>
        }
        {(banner.urlLink || banner.codiceServizio) && (
          <div className="buttonView">
            <ButtonText2
              className="vai-a-saldo"
              onClick={() => handleNavigation(banner)}
              img="navigazione_avanti"
              descrizione={t("banner.componente.scopriDiPiu")}
              isLink
              notRed
            />
          </div>
        )}
      </div>
    ));

  return (
    <div className={`content-main-banner-view ${className || ""} ${!banners.length ? "home-banner-empty" : ""}`}>
      <CarouselCustom
        className="banner-home-carousel"
        custom={{
          slides: BannerItems,
          autoplayMilliseconds: BannerItems.length > 1 ? 8000 : undefined,
          onSelectSlideIndex: setSlideIndex,
        }}
      />
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) =>
  bindActionCreators(
    {
      sendFeedbackBanner
    },
    dispatch
  );

interface IProps {
  funzionalita: string
  banners: BannerWcmDto[],
  className?: string
}

export type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  IProps;

export default connect(mapStateToProps, mapDispatchToProps)(Banner);

